<app-splash-screen></app-splash-screen>

<app-site-header></app-site-header>

<router-outlet></router-outlet>

<app-site-footer *ngIf="!router.url.includes('cart') && !router.url.includes('password')"></app-site-footer>
